import React, { useMemo } from 'react';
import { Link, TextButton, Text } from '@amzn/storm-ui';
import { LinkedSellingAccount } from '@models/account';
import useIntl from '@i18n/useIntl';
import { getSellingAccountType } from '@features/account-settings/utils';
import ReadOnlyFormField from '@components/form/ReadOnlyFormRow';
import {
  SELLING_ACCOUNT_FIELD_ID,
  SELLING_ACCOUNT_LINK,
  SELLING_ACCOUNT_LINK_FIELD_ID,
  SELLING_ACCOUNT_TYPE_ID,
} from 'src/pages/accountSettings/components/AccountDetails/constants';
import { SellingAccountWrapper } from 'src/pages/accountSettings/style';

const REALM_MESSAGE_KEY_MAP: Record<string, string> = {
  USAmazon: 'multi_mcid_region_americas',
  EUAmazon: 'multi_mcid_region_emea',
  JPAmazon: 'multi_mcid_region_apac',
};

interface SellingAccountsProps {
  sellingAccount: LinkedSellingAccount;
  label: string;
}
const AccountDetailsSellingAccount = ({
  sellingAccount,
  label,
}: SellingAccountsProps) => {
  const { intl } = useIntl();
  const sellingAccountType = useMemo(
    () => getSellingAccountType(intl, sellingAccount.sellingProgram),
    [sellingAccount.sellingProgram],
  );

  return (
    <>
      <ReadOnlyFormField label={label} id={SELLING_ACCOUNT_FIELD_ID}>
        <SellingAccountWrapper>
          <Text>{sellingAccount.displayName}</Text>
          {sellingAccountType && (
            <Text color="secondary" data-testid={SELLING_ACCOUNT_TYPE_ID}>
              {sellingAccountType}
            </Text>
          )}
          {sellingAccount.mcidList && sellingAccount.mcidList.length > 0 && (
            <div>
              {sellingAccount.mcidList.map((merchantAccount) => {
                const realmName =
                  merchantAccount.marketplaces?.[0]?.realm?.name;
                const realmMessageKey = realmName
                  ? REALM_MESSAGE_KEY_MAP[realmName]
                  : undefined;
                const realmDisplay = realmMessageKey
                  ? intl.getMessage(realmMessageKey)
                  : realmName || '';
                return (
                  <Text key={merchantAccount.id} color="secondary">
                    {merchantAccount.id}
                    {realmDisplay && ` (${realmDisplay})`}
                  </Text>
                );
              })}
            </div>
          )}
        </SellingAccountWrapper>
      </ReadOnlyFormField>
      {sellingAccount.url && (
        <ReadOnlyFormField label={''} id={SELLING_ACCOUNT_LINK_FIELD_ID}>
          <TextButton>
            <Link href={sellingAccount.url} target="_blank" external={true}>
              {intl.getMessage(SELLING_ACCOUNT_LINK)}
            </Link>
          </TextButton>
        </ReadOnlyFormField>
      )}
    </>
  );
};

export default AccountDetailsSellingAccount;
